import { GameStateEnums } from '../../../../shared/GameEnums.ts';
import { UIMDeviceHandler } from '../ui_html/UIMDeviceHandler.ts';
export class UIMGameReviewController {
    onEvent(data, eventType) {
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.FeedbackFormSubmitted:
                this.onFeedbackFormSubmitted(data);
                break;
            default:
                break;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    onFeedbackFormSubmitted(rating) {
        if (rating <= 4) return;
        UIMDeviceHandler.requestReview();
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
